<!-- 
bottom
 -->
<template>
  <div class="footer-down0830" id="moreApp">
    <a class="down-a"  @click="jieliuF">更多精彩内容下载APP</a>
  </div>
</template>

<script>
export default {
  name: 'bottom',
  components: {
  },
  props: {
  },
  data() {
    return {
      word: '111'
    }
  },
  methods: {
    goUrl() {
      if(this.isWeixin.in) {
        this.isWeixin.show = true
        this.$emit("envChange", this.isWeixin)
        return
      }
      if (window.navigator.userAgent.indexOf("iPhone") > -1) {
        // setTimeout(() =>{
        //   window.open(this.site.iosUrl)
        // }, 2000)
        // this.goApp(this.site.appIosUrl)
        this.openAppOrDownApp(this.site.appIosUrl, this.site.iosUrl)
      } else {
        // setTimeout(() =>{
        //   window.open(this.site.anUrl)
        // }, 2000)
        // this.goApp(this.site.appAnUrl)
        this.openAppOrDownApp(this.site.appAnUrl, this.site.anUrl)
      }
    },
    jieliuF() {
      if(this.isWeixin.in) {
        this.isWeixin.show = true
        this.$emit("envChange", this.isWeixin)
        return
      }
      const me = this
      this.jieliuhanshu((me.openAppOrDownApp), 1500)
    },
    // 打开app或下载
    openAppOrDownApp() {
      let appUrl, dowmUrl
      if (window.navigator.userAgent.indexOf("iPhone") > -1) {
        appUrl = this.site.appIosUrl
        dowmUrl = this.site.iosUrl
      } else {
        appUrl = this.site.appAnUrl
        dowmUrl = this.site.anUrl
      }
      console.log(appUrl)
      // 唤起app
      window.location.href = appUrl
      setTimeout(() =>{
        let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden 
        if(typeof hidden == "undefined" || hidden == false){
          // App store下载地址
          window.location.href = dowmUrl
        }
      }, 3000);
    },
    goApp(url) {
      window.location.href = url // 唤起app
      // setTimeout( () => {
      //   window.location.href = url // 唤起app
      // }, 2000)
    }
  }
}
</script>
<style lang="less" scoped>
.footer-down0830 {
  height: 15vh;
  .down-a {
    background: #d22830;
  }
}
</style>
